<template>
<!-- 
  纯手写轮播没有过度效果
  可以正常轮播^^
 -->
  <div class="swiperCss">
    <div class="swiperCssImg">
      <div v-for="(item,index) of imgList" :key="index">
        <img :src="item.path" alt="" :class="[index === indexs ? 'active': '']">
      </div>
    </div>
    <div class="point" v-for="(item,index) of imgList" :key="index" :class="[index === indexs ? 'points': 'pointNos']" @mouseenter="pointmOuseenter(index)" @mouseleave="pointMouseleave(index)">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        // { path: require("@/assets/channel/swpscs.png") },
        // { path: require("@/assets/channel/21.jpg") },
      ],
      indexs: 0,
      Time: null,
      ClickFlag: false,
    }
  },
  mounted() {
    this.TimeClick()
  },
  methods: {
    TimeClick() {
      this.ClickFlag = false
      if (this.ClickFlag == false) {
        this.Time = setInterval(() => {
          if (this.indexs == this.imgList.length - 1) {
            this.indexs = this.indexs - 1
          } else {
            this.indexs++
          }
        }, 2000)
      }
    },
    pointmOuseenter(index) {
      this.ClickFlag = true
      clearInterval(this.Time)
      this.Time = null
      //console.log(this.indexs, 'indexs');
      this.indexs = index
    },
    pointMouseleave(index) {
      this.TimeClick()
    },
  }
}
</script>

<style lang="less" scoped>
.points {
  background-color: #00266d;
}
.pointNos {
  background-color: #a1a9b3;
}
.active{
  z-index: 99;
}
.swiperCss {
  width: 100%;
  height: 440px;
  // border: 1px solid red;
  position: relative;

  .swiperCssImg {
    width: 100%;
    height: 100%;
  }

  .point {
    display: inline-block;
    width: 32px;
    height: 4px;
    // border: 1px solid red;
    position: relative;
    top: -35px;
    left: 810px;
    margin-left: 20px;
    z-index: 99;
  }
}
.swiperCss img {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>